'use strict';

exports.__esModule = true;
exports.default = RestrictedMethodError;
function RestrictedMethodError(message) {
  this.name = 'RestrictedMethodError';
  this.message = message;
}

RestrictedMethodError.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kindergarten/lib/errors/RestrictedMethodError.js
// module id = 9Y19
// module chunks = 40